export const GET_SHOWCASE = "GET_SHOWCASE";
export const CREATE_SHOWCASE = "CREATE_SHOWCASE";
export const UPDATE_SHOWCASE = "UPDATE_SHOWCASE";
export const DELETE_SHOWCASE = "DELETE_SHOWCASE";
